import React, { useState } from "react";
import Minus from "images/Minus.svg";
import Plus from "images/Plus.svg";
import NcImage from "images/faq.png";

interface SectionProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}

const Section: React.FC<SectionProps> = ({
  title,
  children,
  isOpen,
  onToggle,
}) => {
  return (
    <div className=" my-4 rounded-xl">
      <button
        onClick={onToggle}
        className="flex justify-between w-full space-x-4  py-6 text-left items-center"
      >
        <span className="text-lg font-semibold leading-7 text-left text-[#121212]">
          {title}
        </span>
        <span>
          {isOpen ? (
            <svg
              width="12"
              height="3"
              viewBox="0 0 12 3"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.166664 0.666748V2.33341H11.8333V0.666748H0.166664Z"
                fill="#050B20"
              />
            </svg>
          ) : (
            <svg
              width="12"
              height="13"
              viewBox="0 0 12 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.16666 5.66675V0.666748H6.83333V5.66675H11.8333V7.33341H6.83333V12.3334H5.16666V7.33341H0.166664V5.66675H5.16666Z"
                fill="#121212"
                fill-opacity="0.8"
              />
            </svg>
          )}
        </span>
      </button>
      {isOpen && <div className="px-4 py-2">{children}</div>}
    </div>
  );
};

const FAQ: React.FC = () => {
  const [openSectionIndex, setOpenSectionIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenSectionIndex(openSectionIndex === index ? null : index);
  };
  return (
    <>
      <div className="justify-center mb-8 text-center">
        <h2 className="text-4xl font-semibold">Frequently Asked Questions</h2>
        <p>Let's see what people asking </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-14">
        

        <div className="">
          <Section
            title="What is the minimum age requirement for renting?"
            isOpen={openSectionIndex === 1}
            onToggle={() => handleToggle(1)}
          >
            <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
              You must be 21 or older with a valid drivers license to rent.
            </span>
          </Section>

          <Section
            title="Is there a security deposit needed for rentals?"
            isOpen={openSectionIndex === 3}
            onToggle={() => handleToggle(3)}
          >
            <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
              There’s a security deposit of $250, the security deposit is for
              gas, smoking and cleaning. If any of these things are violated,
              you’ll be charged.
            </span>
          </Section>
          <Section
            title=" Is there a minimum rental duration?"
            isOpen={openSectionIndex === 4}
            onToggle={() => handleToggle(4)}
          >
            <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
              Yes, our minimum rental period is 24 hours.
            </span>
          </Section>
          <Section
            title="Do I need my own auto insurance to rent?"
            isOpen={openSectionIndex === 5}
            onToggle={() => handleToggle(5)}
          >
            <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
              You do not need your own insurance. It is a requirement to
              purchase insurance.
            </span>
          </Section>
        </div>
        <div className="flex flex-col space-y-10 justify-center">
          <img className="" src={NcImage} alt="" />
        </div>
      </div>
    </>
  );
};

export default FAQ;
